import { r as e } from "./index-D8rQzb7O.js";
const s = e("Browser", {
  web: () => import("./web-CTtA6ubD.js").then((r) => new r.BrowserWeb())
});
export {
  s as B
};
//# sourceMappingURL=index-BcZ70a8s.js.map
